import React from "react";
import { FormattedNumber, IntlProvider, useIntl } from "react-intl";

const PcoPointsLabel = ({
  points,
  labels,
}: {
  points: number;
  labels: Record<string, string>
}) => {
  const { locale } = useIntl();
  return (
    <>
      {labels['2K69pBPn82fpWmuYMV28Rp']}
            &nbsp;
      <IntlProvider locale={`${locale}-CA`}>
        <FormattedNumber
          value={points / 1000}
          // eslint-disable-next-line react/style-prop-object
          style="currency"
          currency="CAD"
          maximumFractionDigits={0}
          minimumFractionDigits={0}
        />
      </IntlProvider>
    </>
  );
};

export default PcoPointsLabel;
